// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mpng-ux-avatar.head-only{clip-path:inset(0 0 50% 0)}`, "",{"version":3,"sources":["webpack://./src/components/avatar/avatar.scss"],"names":[],"mappings":"AACE,0BACE,0BAAA","sourcesContent":[".mpng-ux-avatar {\n  &.head-only {\n    clip-path: inset(0 0 50% 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
